export default __webpack_public_path__ + "static/media/hero-3.09b1fcff.jpg";